const refreshNavbar = (state = {}, action) => {
  if (action.type === "navbarRefresh") {
    return (state = action.payload);
  } else {
    return state;
  }
};
export default refreshNavbar;
